import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useQueryClient } from "@tanstack/react-query"
import { Button } from "@/components/ui/button"
import SpecialDeckLayout from "@/modules/flashcards/features/special-deck/special-deck-layout"
import useGetSpecialDeck from "@/modules/flashcards/queries/use-get-special-deck"
import { isClientError } from "@educabot/fetcher"
import { useNoLifeAlert } from "@/modules/app/stores/use-no-life-alert"
import useCanContinueLearning from "@/modules/user/hooks/use-can-continue-learning"
import { useLearningPaths } from "@/modules/app/stores/use-lp-store"

export default function SpecialDeckPage() {
  const navigate = useNavigate()
  const { selectedLearningPath } = useLearningPaths()
  const { isPending, isError, data, error, isSuccess } = useGetSpecialDeck({
    learningPathId: selectedLearningPath.id,
  })
  const queryClient = useQueryClient()
  const canContinueLearning = useCanContinueLearning()
  const { setIsOpen: openNoLifeAlert } = useNoLifeAlert()

  useEffect(() => {
    if (!canContinueLearning) {
      openNoLifeAlert(true)
      navigate("/flashcards")
    }
  }, [])

  useEffect(() => {
    if (isSuccess) {
      queryClient.invalidateQueries({ queryKey: ["get-user"] })
    }
  }, [isSuccess])

  return (
    <div className="flex size-full flex-col items-center justify-center">
      {isPending ? (
        <p>Cargando...</p>
      ) : isError ? (
        <div className="flex w-full flex-col items-center gap-4 text-center">
          <p>Algo salió mal.</p>
          {isClientError(error) && <p>{error.message}</p>}
          <Button onClick={() => navigate("/flashcards")}>Volver</Button>
        </div>
      ) : (
        <SpecialDeckLayout data={data.data} />
      )}
    </div>
  )
}
